export default __webpack_public_path__ + "static/media/PurposeModel.b4bb9f37.png";